import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/images/cod-logo.png'
import _imports_1 from '@/app/ui/assets/images/dfod-logo.png'


const _hoisted_1 = { class: "p-6" }
const _hoisted_2 = { class: "flex justify-between w-full" }
const _hoisted_3 = { class: "font-semibold text-12px xxl:text-14px" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "text-12px opacity-50" }, " Sebelum menyetujui permintaan ini, pastikan seluruh data Client sudah benar dan sesuai. Persetujuan ini mencakup pembuatan Client dan pengajuan harga. ", -1)
const _hoisted_5 = { class: "flex gap-x-6 w-1/6" }
const _hoisted_6 = { class: "p-6 flex flex-row items-center" }
const _hoisted_7 = { class: "w-2/12 text-center" }
const _hoisted_8 = { class: "py-2 break-words elipsis-2 text-xl text-black-lp-300 font-semibold" }
const _hoisted_9 = { class: "pl-6 border-l" }
const _hoisted_10 = { class: "flex my-1" }
const _hoisted_11 = { class: "capitalize" }
const _hoisted_12 = {
  key: 0,
  class: "rounded bg-gray-lp-200 text-black-lp-300 p-4 space-y-4"
}
const _hoisted_13 = { class: "flex space-x-2" }
const _hoisted_14 = {
  key: 1,
  class: "flex gap-x-6 text-16px border-b border-gray-lp-400"
}
const _hoisted_15 = { class: "space-y-6 p-6" }
const _hoisted_16 = { class: "flex justify-between" }
const _hoisted_17 = { class: "w-1/12" }
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_24 = { class: "flex flex-wrap gap-2 pt-2" }
const _hoisted_25 = {
  key: 2,
  class: "text-14px font-semibold text-gray-lp-300"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_30 = { class: "flex" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_33 = { class: "grid grid-cols-2 gap-6" }
const _hoisted_34 = {
  key: 0,
  class: "py-3 col-span-2"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "py-3 col-span-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "p-field-checkbox mt-3 ml-2 flex flex-row" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "max-w-none w-16",
    alt: "cod-logo"
  }),
  /*#__PURE__*/_createVNode("label", {
    for: "cod",
    class: "mt-4 ml-2.5"
  }, "Cash on delivery")
], -1)
const _hoisted_37 = { class: "flex w-2/12 bg-gray-lp-200 py-4 rounded-md text-black-lp-300 justify-center mb-6 mt-4" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "p-field-checkbox mt-3 ml-2 mb-2 flex flex-row" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "max-w-none w-16",
    alt: "cod-logo"
  }),
  /*#__PURE__*/_createVNode("label", {
    for: "cod",
    class: "mt-2 ml-2.5"
  }, "Delivery fee on delivery")
], -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "py-3 col-span-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_41 = { class: "flex" }
const _hoisted_42 = { class: "flex" }
const _hoisted_43 = { class: "my-1" }
const _hoisted_44 = { class: "text-black-lp-300 capitalize" }
const _hoisted_45 = { class: "flex" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_48 = { class: "flex" }
const _hoisted_49 = { class: "flex" }
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "border-b-2" })
], -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-lp-1100 p-2 opacity-75 mb-2" }, "Pengajuan Harga", -1)
const _hoisted_52 = { class: "p-6 flex" }
const _hoisted_53 = { class: "flex my-1 gap-x-4" }
const _hoisted_54 = { class: "capitalize" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { class: "w-3/5 flex flex-col" }
const _hoisted_57 = {
  key: 0,
  class: "w-full flex"
}
const _hoisted_58 = { class: "my-1" }
const _hoisted_59 = {
  key: 0,
  class: "py-3"
}
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "border-b-2" }, null, -1)
const _hoisted_61 = { class: "flex w-full" }
const _hoisted_62 = { class: "w-3/5 flex flex-col" }
const _hoisted_63 = { class: "my-1" }
const _hoisted_64 = { class: "my-1" }
const _hoisted_65 = { class: "w-full flex justify-between" }
const _hoisted_66 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_67 = { class: "w-1/5" }
const _hoisted_68 = { class: "pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Card = _resolveComponent("Card")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CreateUpdate = _resolveComponent("CreateUpdate")!
  const _component_Title = _resolveComponent("Title")!
  const _component_DetailTaxInformation = _resolveComponent("DetailTaxInformation")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_tempalte = _resolveComponent("tempalte")!
  const _component_DetailDeliveryOrder = _resolveComponent("DetailDeliveryOrder")!
  const _component_DetailBillingInformation = _resolveComponent("DetailBillingInformation")!
  const _component_DetailBankSettlementInformation = _resolveComponent("DetailBankSettlementInformation")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_DownloadAttachment = _resolveComponent("DownloadAttachment")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_ModalEditDetail = _resolveComponent("ModalEditDetail")!
  const _component_RenewRates = _resolveComponent("RenewRates")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.getDetail,
      title: _ctx.detailData.clientName,
      fullPage: "",
      verticalSeparator: false
    }, {
      data: _withCtx(() => [
        (_ctx.isApproveAble)
          ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_1, [
                  _createVNode("div", _hoisted_2, [
                    _createVNode("div", _hoisted_3, [
                      _createTextVNode(" Pembuatan " + _toDisplayString(_ctx.type) + " Client ", 1),
                      _hoisted_4
                    ]),
                    _createVNode("div", _hoisted_5, [
                      _createVNode(_component_button_outline, {
                        title: "Tolak",
                        onClick: _ctx.openRejectConfirmation,
                        class: "text-red-lp-300"
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_button_fill, {
                        title: "Setujui",
                        onClick: _ctx.openApprovalConfirmation,
                        class: "bg-red-lp-300"
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Card, null, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("img", {
                  class: "mx-auto",
                  src: require(`@/app/ui/assets/svg/client-ilustration.svg`),
                  alt: ""
                }, null, 8, ["src"]),
                _createVNode("div", _hoisted_8, _toDisplayString(_ctx.detailData.clientName), 1)
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_DataWrapper, {
                  label: "Status Client",
                  class: "pb-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_10, [
                      _createVNode("div", {
                        class: 
                    `rounded-full px-2 py-0 text-center ${
                      _ctx.detailData.clientStatus.toLowerCase() === 'approved'
                        ? 'bg-green-lp-300 text-green-lp-200'
                        : _ctx.detailData.clientStatus.toLowerCase() === 'waiting'
                        ? 'bg-yellow-lp-200 text-yellow-lp-100'
                        : 'bg-red-300 text-red-lp-200'
                    }`
                  
                      }, [
                        _createVNode("span", _hoisted_11, _toDisplayString(_ctx.detailData.clientStatus.toLowerCase() === "waiting"
                        ? "Pending"
                        : "Rejected"), 1)
                      ], 2)
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.detailData.clientStatus.toLowerCase() === 'rejected')
                  ? (_openBlock(), _createBlock("div", _hoisted_12, [
                      _createVNode("div", _hoisted_13, [
                        _createVNode("img", {
                          src: require(`@/app/ui/assets/svg/info-red.svg`),
                          alt: ""
                        }, null, 8, ["src"]),
                        _createVNode("div", null, _toDisplayString(_ctx.detailData.clientStatusUpdatedReason), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_CreateUpdate, {
                  createdAt: _ctx.detailData.clientCreatedAt,
                  createdBy: _ctx.detailData.clientCreatedBy,
                  updatedAt: _ctx.detailData.clientUpdatedAt,
                  updatedBy: _ctx.detailData.clientUpdatedBy
                }, null, 8, ["createdAt", "createdBy", "updatedAt", "updatedBy"])
              ])
            ])
          ]),
          _: 1
        }),
        (_ctx.type === 'Induk')
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                return (_openBlock(), _createBlock("button", {
                  key: tab.name,
                  onClick: ($event: any) => (_ctx.changeTabs(tab.isRatesTab, tab.name)),
                  class: 
            `pb-4 font-semibold hover:text-red-lp-100 focus:outline-none ${
              _ctx.isTabActive(tab.name)
                ? 'text-red-lp-100 border-b-2 border-red-lp-100'
                : 'text-gray-lp-600'
            }`
          
                }, _toDisplayString(tab.title), 11, ["onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_Card, null, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createVNode(_component_Title, {
                  label: `Detail ` + _ctx.type + ` Client`
                }, null, 8, ["label"]),
                _createVNode("div", _hoisted_17, [
                  (_ctx.isEditAble)
                    ? (_openBlock(), _createBlock(_component_button_outline, {
                        key: 0,
                        onClick: _ctx.goEdit,
                        iconLeft: "pencil-alt",
                        title: "Ubah"
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_DataWrapper, {
                label: "Tipe Client",
                value: _ctx.type + ' Client'
              }, null, 8, ["value"]),
              _createVNode("div", _hoisted_18, [
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: "ID Client",
                  value: _ctx.idClient
                }, null, 8, ["value"]),
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: "Kode Client",
                  value: _ctx.detailData.clientCode
                }, null, 8, ["value"])
              ]),
              _createVNode("div", _hoisted_19, [
                _createVNode(_component_DataWrapper, {
                  class: "w-6/12",
                  label: 'Nama ' + _ctx.type + ' Client',
                  value: _ctx.detailData.clientName
                }, null, 8, ["label", "value"]),
                (_ctx.type === 'Induk')
                  ? (_openBlock(), _createBlock(_component_DataWrapper, {
                      key: 0,
                      class: "w-6/12",
                      label: "Kategori Client",
                      value: _ctx.clientCategory
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.type === 'Induk')
                ? (_openBlock(), _createBlock(_component_DataWrapper, {
                    key: 0,
                    class: "w-7/12 capitalize",
                    label: "Company Size",
                    value: _ctx.detailData.clientCompanySize
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              _createVNode(_component_DataWrapper, {
                class: "w-7/12",
                label: "Alamat",
                value: _ctx.detailData.clientAddress
              }, null, 8, ["value"]),
              _createVNode(_component_DataWrapper, {
                class: "w-7/12",
                label: "Kecamatan, Kota",
                value: 
              _ctx.detailData.clientDistrict?.name +
                ' , ' +
                _ctx.detailData.clientCity.name
            
              }, null, 8, ["value"]),
              _createVNode("div", _hoisted_20, [
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: "Email",
                  value: _ctx.detailData.clientEmail
                }, null, 8, ["value"]),
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: "No. Telepon",
                  value: '+' + _ctx.convertPhoneNumber(_ctx.detailData.clientPhone)
                }, null, 8, ["value"])
              ]),
              (_ctx.type === 'Cabang')
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createVNode("div", _hoisted_21, [
                      _createVNode(_component_DataWrapper, {
                        class: "w-1/2",
                        label: "COD",
                        value: _ctx.detailData.clientIsCod ? 'Ya' : 'Tidak'
                      }, null, 8, ["value"]),
                      _createVNode(_component_DataWrapper, {
                        class: "w-1/2",
                        label: "Delivery Order",
                        value: _ctx.detailData.clientIsDo ? 'Ya' : 'Tidak'
                      }, null, 8, ["value"])
                    ]),
                    _createVNode(_component_DataWrapper, {
                      class: "w-6/12",
                      label: "No. Registrasi Pajak (NPWP)",
                      value: _ctx.detailData.clientTaxNumber
                    }, null, 8, ["value"])
                  ], 64))
                : _createCommentVNode("", true),
              _hoisted_22,
              (_ctx.type === 'Induk')
                ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                    _createVNode(_component_DetailTaxInformation, { detailData: _ctx.detailData }, null, 8, ["detailData"]),
                    _hoisted_23
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.type === 'Cabang')
                ? (_openBlock(), _createBlock(_component_tempalte, { key: 3 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Title, { label: "Konfigurasi retur" }),
                      (_ctx.detailData.isReturnConfig)
                        ? (_openBlock(), _createBlock(_component_DataWrapper, {
                            key: 0,
                            class: "w-1/2 py-2",
                            label: "Batas konfirmasi retur",
                            value: _ctx.detailData.returnConfigLimit + ' hari'
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true),
                      (_ctx.detailData.isReturnConfig)
                        ? (_openBlock(), _createBlock(_component_DataWrapper, {
                            key: 1,
                            class: "w-1/2 py-2",
                            label: "Alasan retur perlu dikonfirmasi",
                            value: _ctx.getReasonList(_ctx.detailData.returnConfigReasonIds)
                          }, {
                            default: _withCtx(() => [
                              _createVNode("div", _hoisted_24, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getReasonList(_ctx.detailData.returnConfigReasonIds), (reason, id) => {
                                  return (_openBlock(), _createBlock(_component_Chips, {
                                    key: id,
                                    label: reason
                                  }, null, 8, ["label"]))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          }, 8, ["value"]))
                        : _createCommentVNode("", true),
                      (!_ctx.detailData.isReturnConfig)
                        ? (_openBlock(), _createBlock("div", _hoisted_25, "Tidak ada konfigurasi"))
                        : _createCommentVNode("", true),
                      _hoisted_26
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_Title, { label: "Informasi Kontak" }),
              _createVNode("div", _hoisted_27, [
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: "Nama",
                  value: _ctx.detailData.clientContact.clientContactName
                }, null, 8, ["value"]),
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: "Jabatan",
                  value: _ctx.detailData.clientContact.clientContactJobTitle
                }, null, 8, ["value"])
              ]),
              _createVNode("div", _hoisted_28, [
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: "Email",
                  value: _ctx.detailData.clientContact.clientContactEmail
                }, null, 8, ["value"]),
                _createVNode(_component_DataWrapper, {
                  class: "w-1/2",
                  label: "No. Telepon",
                  value: 
                '+' +
                  _ctx.convertPhoneNumber(
                    _ctx.detailData.clientContact.clientContactPhone
                  )
              
                }, null, 8, ["value"])
              ]),
              (_ctx.isClientParent)
                ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                    _hoisted_29,
                    _createVNode(_component_Title, { label: "Informasi Pembayaran" }),
                    _createVNode("div", _hoisted_30, [
                      _createVNode(_component_DataWrapper, {
                        class: "w-1/2",
                        label: "Metode Pembayaran",
                        value: _ctx.detailData.clientPaymentMethod?.name
                      }, null, 8, ["value"])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.type === 'Cabang')
                ? (_openBlock(), _createBlock(_Fragment, { key: 5 }, [
                    (_ctx.detailData.clientIsDo)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _hoisted_31,
                          _createVNode(_component_DetailDeliveryOrder, { detailData: _ctx.detailData }, null, 8, ["detailData"])
                        ], 64))
                      : _createCommentVNode("", true),
                    _hoisted_32,
                    (_ctx.detailData.clientIsCod)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_Title, { label: "Pengembalian STT return" }),
                          _createVNode(_component_Title, {
                            label: "Detail Penerima",
                            fontSize: 14
                          }),
                          _createVNode("div", _hoisted_33, [
                            _createVNode(_component_DataWrapper, {
                              class: "col-span-2",
                              label: "Nama Penerima",
                              value: _ctx.detailData.clientCodReject.clientCodName
                            }, null, 8, ["value"]),
                            _createVNode(_component_DataWrapper, {
                              class: "col-span-2",
                              label: "Alamat Penerima",
                              value: _ctx.detailData.clientCodReject.clientCodAddress
                            }, null, 8, ["value"]),
                            _createVNode(_component_DataWrapper, {
                              label: "Kecamatan, Kota",
                              value: _ctx.detailData.clientCodReject.clientCodDistrict?.name
                            }, null, 8, ["value"]),
                            _createVNode(_component_DataWrapper, {
                              label: "No. Telepon",
                              value: 
                    '+' +
                      _ctx.convertPhoneNumber(
                        _ctx.detailData.clientCodReject.clientCodPhone
                      )
                  
                            }, null, 8, ["value"]),
                            (_ctx.isEnableCodOngkir)
                              ? (_openBlock(), _createBlock("div", _hoisted_34, [
                                  _hoisted_35,
                                  _createVNode(_component_Title, {
                                    label: "Tipe COD",
                                    fontSize: 14,
                                    class: "col-span-2"
                                  }),
                                  (_ctx.detailData.clientIsCod)
                                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                                        key: 0,
                                        class: "col-span-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_36
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode("div", _hoisted_37, [
                                    _createVNode("span", null, _toDisplayString(_ctx.detailData.clientCodConfigAmount.name), 1)
                                  ]),
                                  (_ctx.detailData.clientIsDfod)
                                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                                        key: 1,
                                        class: "col-span-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_38
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_39,
                            _createVNode(_component_Title, {
                              label: "Biaya & Persentase COD",
                              fontSize: 14,
                              class: "col-span-2"
                            }),
                            _createVNode(_component_DataWrapper, {
                              label: "Biaya COD",
                              value: _ctx.detailData.clientCodReject.clientCodCommission + '%'
                            }, null, 8, ["value"]),
                            (_ctx.isEnableCodOngkir)
                              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                                  key: 1,
                                  label: "Persentase Diskon COD",
                                  value: _ctx.detailData.clientCodShipmentDiscount + '%'
                                }, null, 8, ["value"]))
                              : _createCommentVNode("", true),
                            (_ctx.isEnableCodBooking)
                              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                                  key: 2,
                                  class: "w-1/2",
                                  label: "Biaya PAD",
                                  value: _ctx.detailData.clientPadFee + '%'
                                }, null, 8, ["value"]))
                              : _createCommentVNode("", true)
                          ]),
                          _hoisted_40
                        ], 64))
                      : _createCommentVNode("", true),
                    _createVNode(_component_Title, { label: "Detail Induk Client" }),
                    _createVNode("div", _hoisted_41, [
                      _createVNode(_component_DataWrapper, {
                        class: "w-1/2",
                        label: "Nama Induk Client",
                        value: 
                  _ctx.detailData.clientParentName.length === 0
                    ? '-'
                    : _ctx.detailData.clientParentName
                
                      }, null, 8, ["value"]),
                      _createVNode(_component_DataWrapper, {
                        class: "w-1/2",
                        label: "Nama Partner POS",
                        value: 
                  _ctx.detailData.clientPartner.clientPartnerName.length === 0
                    ? '-'
                    : _ctx.detailData.clientPartner.clientPartnerName
                
                      }, null, 8, ["value"])
                    ]),
                    _createVNode("div", _hoisted_42, [
                      _createVNode(_component_DataWrapper, {
                        class: "w-1/2",
                        label: "Komisi POS",
                        value: _ctx.posCommision + '%'
                      }, null, 8, ["value"]),
                      _createVNode(_component_DataWrapper, {
                        class: "w-1/2",
                        label: "Tipe Komisi"
                      }, {
                        default: _withCtx(() => [
                          _createVNode("div", _hoisted_43, [
                            _createVNode("div", _hoisted_44, _toDisplayString(_ctx.detailData.clientPartner
                        .clientPartnerQuantifierCommission ===
                      "publish_rate_shipping_surcharge"
                        ? "Publish Rate + Shipping Surcharge"
                        : _ctx.startCase(
                            _ctx.detailData.clientPartner.clientPartnerQuantifierCommission.replace(
                              /_/g,
                              " "
                            )
                          )), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", _hoisted_45, [
                      _createVNode(_component_DataWrapper, {
                        class: "w-1/2",
                        label: "Pembilang Komisi"
                      }, {
                        default: _withCtx(() => [
                          _createVNode("div", null, _toDisplayString(_ctx.startCase(
                      _ctx.detailData.clientPartner.clientPartnerNumeratorCommision
                    )), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.type === 'Induk')
                ? (_openBlock(), _createBlock(_Fragment, { key: 6 }, [
                    _hoisted_46,
                    _createVNode(_component_DetailBillingInformation, { detailData: _ctx.detailData }, null, 8, ["detailData"]),
                    _hoisted_47,
                    _createVNode(_component_Title, { label: "Informasi Bank" }),
                    _createVNode("div", _hoisted_48, [
                      _createVNode(_component_DataWrapper, {
                        class: "w-1/2",
                        label: "Nama Rekening",
                        value: _ctx.beneficiaryDetail[0]?.bankAccountName
                      }, null, 8, ["value"]),
                      _createVNode(_component_DataWrapper, {
                        class: "w-1/2 capitalize",
                        label: "Nama Bank",
                        value: _ctx.beneficiaryDetail[0]?.bankName
                      }, null, 8, ["value"])
                    ]),
                    _createVNode("div", _hoisted_49, [
                      _createVNode(_component_DataWrapper, {
                        class: "w-1/2",
                        label: "No Rekening",
                        value: _ctx.beneficiaryDetail[0]?.bankAccountNumber
                      }, null, 8, ["value"]),
                      _createVNode(_component_DataWrapper, {
                        class: "w-1/2",
                        label: "Email",
                        value: _ctx.beneficiaryDetail[0]?.bankAccountEmail
                      }, null, 8, ["value"])
                    ]),
                    _hoisted_50,
                    _createVNode(_component_DetailBankSettlementInformation, { detailData: _ctx.detailData }, null, 8, ["detailData"])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.activeTab === 'detail-induk-client']
        ]),
        _withDirectives(_createVNode("div", null, [
          _hoisted_51,
          _createVNode(_component_Card, null, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_52, [
                _createVNode(_component_DataWrapper, {
                  label: "Status Harga",
                  class: "pb-2 w-1/6"
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_53, [
                      _createVNode("div", {
                        class: 
                    `rounded-full px-2 py-0 text-center ${
                      _ctx.detailData.clientCurrentRate.clientStatusCustomRate.toLowerCase() ===
                      'approved'
                        ? 'bg-green-lp-300 text-green-lp-200'
                        : _ctx.detailData.clientCurrentRate.clientStatusCustomRate.toLowerCase() ===
                          'requested'
                        ? 'bg-yellow-lp-200 text-yellow-lp-100'
                        : _ctx.detailData.clientCurrentRate.clientStatusCustomRate.toLowerCase() ===
                          'uploading'
                        ? 'bg-yellow-lp-300 text-white'
                        : 'bg-red-300 text-red-lp-200'
                    }`
                  
                      }, [
                        _createVNode("span", _hoisted_54, [
                          _createTextVNode(_toDisplayString(_ctx.detailData.clientCurrentRate.clientStatusCustomRate) + " ", 1),
                          (
                        _ctx.detailData.clientCurrentRate.clientStatusCustomRate.toLowerCase() ===
                          'uploading'
                      )
                            ? (_openBlock(), _createBlock("span", _hoisted_55, _toDisplayString(_ctx.detailData.dataProcessed) + " / " + _toDisplayString(_ctx.detailData.totalData), 1))
                            : _createCommentVNode("", true)
                        ])
                      ], 2),
                      (
                    _ctx.detailData.clientCurrentRate.clientStatusCustomRate.toLowerCase() ===
                      'uploading' &&
                      _ctx.detailData.dataProcessed < _ctx.detailData.totalData &&
                      _ctx.priceTypeRenewRates !== 'basic'
                  )
                        ? (_openBlock(), _createBlock(_component_lp_button, {
                            key: 0,
                            compact: "",
                            "text-color": "red-lp-100",
                            flat: "",
                            title: "Coba Lagi",
                            onClick: _ctx.retryUploadClientRate
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                (
                _ctx.detailData.clientCurrentRate.clientStatusCustomRate.toLowerCase() !==
                  'uploading'
              )
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      (_ctx.type === 'Induk')
                        ? (_openBlock(), _createBlock(_component_DataWrapper, {
                            key: 0,
                            class: "w-2/6",
                            label: "Periode Harga",
                            value: _ctx.basicRatePeriod
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_56, [
                        (_ctx.detailData.clientCurrentRate.clientVersionBaseRate)
                          ? (_openBlock(), _createBlock("div", _hoisted_57, [
                              _createVNode(_component_DataWrapper, {
                                class: "w-2/6 pr-1",
                                label: "Versi Harga Normal",
                                value: _ctx.detailData.clientCurrentRate.clientVersionBaseRate
                              }, null, 8, ["value"]),
                              _createVNode(_component_DataWrapper, {
                                class: "w-1/6",
                                label: "Diskon",
                                value: 
                      `${_ctx.detailData.clientCurrentRate.clientDiscountBaseRate}%`
                    
                              }, null, 8, ["value"]),
                              (_ctx.type === 'Induk')
                                ? (_openBlock(), _createBlock(_component_DataWrapper, {
                                    key: 0,
                                    label: "Berkas Lampiran",
                                    class: "w-3/5"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode("div", _hoisted_58, [
                                        _createVNode(_component_DownloadAttachment, {
                                          name: 
                          _ctx.detailData.clientCurrentRate.clientFileNameBaseRate
                        ,
                                          url: _ctx.detailData.clientCurrentRate.clientFileBaseRate,
                                          img: true,
                                          maxLength: 40,
                                          bordered: false
                                        }, null, 8, ["name", "url"])
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (
                    _ctx.detailData.clientIsCustomRate !== 'basic' &&
                      _ctx.type === 'Induk'
                  )
                          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                              (_ctx.detailData.clientCurrentRate.clientVersionBaseRate)
                                ? (_openBlock(), _createBlock("div", _hoisted_59, [
                                    _hoisted_60
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("div", _hoisted_61, [
                                _createVNode(_component_DataWrapper, {
                                  class: "w-6/12 pr-6",
                                  label: "Versi Harga Khusus",
                                  value: 
                        _ctx.detailData.clientCurrentRate.clientVersionCustomRate
                      
                                }, null, 8, ["value"]),
                                _createVNode("div", _hoisted_62, [
                                  _createVNode(_component_DataWrapper, {
                                    label: 
                          `Berkas Lampiran ${
                            _ctx.detailData.clientCurrentRate.clientVersionBaseRate
                              ? 'Asli'
                              : ''
                          }`
                        ,
                                    class: "w-full"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode("div", _hoisted_63, [
                                        _createVNode(_component_DownloadAttachment, {
                                          name: 
                              _ctx.detailData.clientCurrentRate
                                .clientFileNameCustomRate
                            ,
                                          url: 
                              _ctx.detailData.clientCurrentRate.clientFileCustomRate
                            ,
                                          maxLength: 40,
                                          img: true,
                                          bordered: false
                                        }, null, 8, ["name", "url"])
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["label"]),
                                  (
                          _ctx.detailData.clientCurrentRate.clientErrorFileCustomRate
                        )
                                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                                        key: 0,
                                        label: "Berkas Lampiran gagal",
                                        class: "w-full"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode("div", _hoisted_64, [
                                            _createVNode(_component_DownloadAttachment, {
                                              name: 
                              _ctx.detailData.clientCurrentRate
                                .clientErrorNameCustomRate
                            ,
                                              url: 
                              _ctx.detailData.clientCurrentRate
                                .clientErrorFileCustomRate
                            ,
                                              img: true,
                                              maxLength: 40,
                                              error: "",
                                              errorCaption: "Terdapat kesalahan pada berkas"
                                            }, null, 8, ["name", "url"])
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ], 64))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_65, [
                          _hoisted_66,
                          _createVNode("div", _hoisted_67, [
                            (_ctx.isEditAble)
                              ? (_openBlock(), _createBlock(_component_button_fill, {
                                  key: 0,
                                  title: "Perbaiki",
                                  onClick: _cache[1] || (_cache[1] = () => _ctx.onConfirmFixingRates(true)),
                                  class: "bg-red-lp-300 w-1/5"
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, _ctx.activeTab === 'harga']
        ])
      ]),
      _: 1
    }, 8, ["onBack", "loading", "error", "errorType", "onTryAgain", "title"]),
    (_ctx.isShowModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onSubmit: _ctx.confirmationModal?.onSubmit,
          onClose: _ctx.onResetModal,
          title: _ctx.confirmationModal?.title,
          message: _ctx.confirmationModal?.message,
          image: "warning",
          textSuccess: _ctx.confirmationModal?.textSuccess,
          textCancel: "Kembali",
          class: "px-8"
        }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onRejectToEdit,
      onClose: _ctx.closeRejectToEditConfirmation,
      title: "Sudahkah Anda Download Berkas Failed ?",
      message: "Silahkan download berkas terlebih dahulu untuk melihat kesalahan.",
      image: "warning",
      textSuccess: "Ubah",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.rejectToEditConfirmation]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onRejected,
      onClose: _ctx.closeRejectConfirmation,
      title: "Konfirmasi Penolakan Client",
      message: 
      `${
        _ctx.type === 'Induk' ? 'Pilih' : 'Masukan'
      } alasan penolakan agar mempermudah dalam perbaikan aktivitas`
    ,
      image: "warning",
      isDisabled: _ctx.isDisableReject,
      textSuccess: "Tolak",
      textCancel: "Kembali",
      class: "px-8"
    }, {
      custom: _withCtx(() => [
        _createVNode("div", _hoisted_68, [
          (_ctx.type === 'Cabang')
            ? (_openBlock(), _createBlock(_component_lp_input, {
                key: 0,
                type: "textarea",
                "text-area-rows": "1",
                modelValue: _ctx.selectedReason,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedReason = $event)),
                placeholder: "Masukan alasan penolakan"
              }, null, 8, ["modelValue"]))
            : (_openBlock(), _createBlock(_component_Select, {
                key: 1,
                class: "w-full text-left",
                dataSelect: _ctx.rejectedReasons,
                value: _ctx.selectedReason,
                isOpenMenu: _ctx.openSelect,
                onOpenSelect: () => (_ctx.openSelect = true),
                onCloseSelect: () => (_ctx.openSelect = false),
                onChooseSelect: 
            (name, val) => {
              _ctx.selectedReason = val;
              _ctx.openSelect = false;
            }
          
              }, null, 8, ["dataSelect", "value", "isOpenMenu", "onOpenSelect", "onCloseSelect", "onChooseSelect"]))
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "onClose", "message", "isDisabled"]), [
      [_vShow, _ctx.rejectConfirmation]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onApprovalSuccess,
      title: _ctx.titleSuccess,
      message: _ctx.messageSuccess,
      image: "image-modal-success",
      textSuccess: "Ok",
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message"]), [
      [_vShow, _ctx.approvalSuccess]
    ]),
    _withDirectives(_createVNode(_component_ErrorMessage, {
      onCancel: _ctx.handleError,
      errorType: _ctx.errorCause,
      onTryAgain: 
      () => {
        _ctx.selectedReason === '' ? _ctx.onApproved() : _ctx.onRejected();
      }
    ,
      modal: ""
    }, null, 8, ["onCancel", "errorType", "onTryAgain"]), [
      [_vShow, _ctx.isErrorRenewRates]
    ]),
    _createVNode(_component_ModalEditDetail, {
      modelValue: _ctx.isEditDetail,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isEditDetail = $event)),
      onResetData: _ctx.getDetail
    }, null, 8, ["modelValue", "onResetData"]),
    (_ctx.isRenewRates)
      ? (_openBlock(), _createBlock(_component_RenewRates, {
          key: 1,
          onClose: _ctx.onResetModal,
          isManagement: false,
          onSuccess: _ctx.getDetail
        }, null, 8, ["onClose", "onSuccess"]))
      : _createCommentVNode("", true)
  ], 64))
}